import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  Typography,
  Input
} from "@mui/material";
import React, { useState } from "react";
import InfoIcon from '@mui/icons-material/Info';
import { useDispatch } from "react-redux";
import { updateTHStatus } from "../app/DeliveryLeadershipSlice";
export default function StatusActionPopup({
  open,
  onClose,
  onFinalSubmit,
  title,
  sessionCode,
  checkBoxid,
  setCheckBoxid,
  setIsChecked,
  setTakeAction,
  courseCode,
  filter
}) {
  const [value, setValue] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [statusReason, setStatusReason] = useState("");
  const dispatch = useDispatch();

  const dropdownDetails = [
    { value: 1, label: "Waiting for Batch Allocation" },
    { value: 2, label: "Scheduled" },
    { value: 3, label: "Reject" },
    { value: 4, label: "Waitlisted" },
    { value: 5, label: "Discarded" }
  ];

  const handleFirstSubmit = () => {
    if (!value) return; 
    if ((value === 3 || value === 5) && !statusReason?.trim()) {
    alert("Please enter a reason for Reject or Discarded");
    return;
  }
    setShowConfirm(true);
  };
  // Final confirmation
  const handleFinalConfirm = () => {
    onFinalSubmit(value);  
    setShowConfirm(false);
    onClose();   
    dispatch(updateTHStatus(courseCode, sessionCode, checkBoxid, statusReason, value, filter));   
    setCheckBoxid([]);
    setIsChecked(false);       
    setTakeAction(false);
  };

  const handleCancelConfirm = () => {
    setShowConfirm(false);
  };

  return (
    <>
      {/* MAIN POPUP */}
      <Dialog open={open && !showConfirm} onClose={onClose} fullWidth maxWidth="xs">
        <DialogTitle sx={{ fontWeight:"bold", display: "flex", justifyContent: "center", mb: 2, alignItems: "center", flexGap: "8px" }}>
           <InfoIcon sx={{color: "orangered", mr: 1}}/> {title || "Take Action"}
        </DialogTitle>
        <DialogContent>
          Assign appropriate status from the dropdown:
          <Select
            fullWidth
            size="small"
            sx={{ mt: 2 }}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          >
            {dropdownDetails.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
          {(value === 3 || value === 5) && (
            <Typography sx={{ mt: 2, color: "red", fontWeight: "bold" }}>
              Reason: <Input
               placeholder="Enter reason for Reject/Discarded" 
               fullWidth size="small" 
               required
               value ={statusReason}
               onChange={(e) => setStatusReason (e.target.value)}
               />
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleFirstSubmit}
            disabled={!value}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* INTERNAL CONFIRMATION POPUP */}
      <Dialog open={showConfirm} onClose={handleCancelConfirm} fullWidth maxWidth="xs">
        <DialogTitle sx={{alignItems:"center", fontWeight:"bold", display: "flex", justifyContent: "center", mb: 2}}>
          <InfoIcon sx={{color: "orangered", mr: 1}}/>  Final Confirmation
        </DialogTitle>

        <DialogContent>
          <Typography>
            Selected Status as: <strong>{dropdownDetails.find(d => d.value === value)?.label}</strong>
          </Typography>
          { statusReason !== "" && <Typography>
            Reason as: <strong>{statusReason}</strong>
          </Typography>}
          <Typography sx={{ mt: 1 }}>Are you are want to proceed??</Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCancelConfirm}>No</Button>
          <Button variant="contained" onClick={handleFinalConfirm}>
            Yes, Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
